@if (HasRequiredPermissions) {
  @if (hasWebSocketChanges()) {
    <div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
      <span class="text-xs text-yellow-800">
        {{ 'Record ' | translate }} {{ 'modified' | translate }}.
        ({{ totalModifiedCount() }} {{ 'changes' | translate }})
      </span>
    </div>
  }
  @if (EntityInstance || isNew()) {
    <div [fieldContext]="this" class="flex flex-col h-full">
      <!-- Titre -->
      <div class="px-6 pt-4 pb-2">
        <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
          @if (isNew()) {
            {{ 'entities.accesscard.newEntity' | translate }}
          } @else {
            {{ 'entities.accesscard.detailEntity' | translate }}
          }
        </h4>
        <div class="flex justify-between items-center">
          <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Zone de contenu -->
      <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
        <div class="{{this.UpdateMode}}">
          <h3 class="{{Skin.formSectionSmallTitle}}">
            <i class="fas fa-id-card mr-2"></i> {{ 'vues.accesscard.detail.sections.card-info' | translate }}
          </h3>
          <div class="space-y-2">
            <div class="space-y-2">
              <!-- Champ selectedPK_Pos (readonly si carte révoquée) -->
              <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_PointOfService" label="entities.account.propreties.pos">
                <app-multi-select #multiSelect
                  [options]="pointOfServiceLookup()"
                  [placeholder]="'Select Sites'"
                  [maxItems]="1"
                  [isMultiselect]="false"
                  [selectedKeys]="editingEntity()?.selectedPK_Pos || []"
                  (selectedKeysChange)="onPOSselectChange($event)"
                  onReady
                  (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)">
                </app-multi-select>
              </app-field-wrapper>
            </div>
            <!-- Champ iD_SP (readonly si carte révoquée) -->
            <app-field-wrapper property="iD_SP" label="entities.accesscard.propreties.iD_SP">
              <input type="text" autocomplete="off" onReady

                class="{{Skin.formInputSmallSize}}"
                (autoBind)="bindingHandler($event, 'iD_SP')">
              </app-field-wrapper>
              <!-- Champ status -->
              <app-field-wrapper property="status" label="entities.accesscard.propreties.status">
                <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)"
                  [lookupData]="accessCardStatusLookup()"
                  [Skin]="Skin"
                  [isEditMode]="!editingEntity()?.isRevoked"
                  (statusChange)="onStatusChange($event)">
                </app-reactive-badge>
              </app-field-wrapper>
              <!-- Champ IsRevoked (fire-once : désactivé si déjà true) -->
              <app-field-wrapper property="isRevoked" label="entities.accesscard.propreties.is-revoked">
                <app-switch-button
                  [checked]="editingEntity()?.isRevoked || false"
                  [disabled]="(EntityInstance?.isRevoked === true && !isNew()) || !canRevokeCard"
                  (checkedChange)="onIsRevokedChange($event)">
                </app-switch-button>
              </app-field-wrapper>
              @if(editingEntity()?.currentVisit?.visitor){
                <div>
                  <div class="border border-2 border-gray-400 rounded rounded-lg bg-gray-200 p-2 mt-[2em]">
                    <i class="fa-solid fa-person"></i>
                    <label class="text-gray-400 font-bold m-2 px-2"> {{ editingEntity()?.currentVisit?.visitor?.fullname}} </label>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Bandeau d'erreurs -->
        @if (generalErrorCount() > 0) {
          <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
            <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
            {{ generalErrorCount() }} erreur(s) dans le formulaire
          </div>
        }
        <!-- Boutons -->
        <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
          @if (HasEditPermission) {
            <button name="SaveButton" data-testid="detail-save"
              type="button" (click)="saveItem()"
              [disabled]="!isFormValid()"
              class="{{Skin.btnPrimary}} uppercase py-2 px-2">
              <i class="far fa-check-square mr-2"></i>
              {{ 'buttons.save' | translate }}
            </button>
          }
          @if (HasEditPermission) {
            <button name="SaveAndCloseButton" data-testid="detail-save-close"
              type="button" (click)="saveAndCloseItem()"
              [disabled]="!isFormValid()"
              class="{{Skin.btnPrimary}} uppercase py-2 px-2">
              <i class="far fa-check-square mr-2"></i>
              {{ 'buttons.save-and-close' | translate }}
            </button>
          }
          <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
            <i class="fas fa-times mr-2"></i>
            {{ 'buttons.cancel' | translate }}
          </button>
        </div>
      </div>
    }
  }
